import InterfaceBooking from "../interface/InterfaceBooking";

export const EMPTY_BOOKING: InterfaceBooking = {
    bookingNumber: '',
    bookedDateTime: '',
    bookedEndDateTime: '',
    bookingId: 0,
    serviceId: 0,
    sectionId: 0,
    telephoneNumber: '',
    emailAddress: '',
    firstName: '',
    lastName: '',
    sectionName: '',
    serviceName: '',
    bookingStatusId: 0,
    bookingStatus: '',
    sendConfirmationSms: false,
    sendReminderEmail: false,
    sendReminderSms: false
}

export default EMPTY_BOOKING;